/**
 * AGE OF EMPIRES II UNITS GAME LOGIC
 * ===================================
 * This file now ONLY exports the unique logic and components for this game.
 * All shared configuration data has been moved to the unified config.
 */

import Aoe2UnitsHint from '../../components/Aoe2UnitsHint/Aoe2UnitsHint';
import Aoe2UnitDirectory from '../../components/Aoe2UnitDirectory/Aoe2UnitDirectory';
import Aoe2UnitsHowToPlay from '../../components/Aoe2UnitsHowToPlay/Aoe2UnitsHowToPlay';

const compareUnits = (guessed, target) => {
  const results = {};

  ['building', 'unit_type', 'range', 'age'].forEach(field => {
    results[field] = guessed[field] === target[field] ? 'correct' : 'incorrect';
  });

  // Cost comparison
  if (guessed.cost === target.cost) {
    results.cost = 'correct';
  } else {
    const guessedResources = guessed.cost.split('/');
    const targetResources = target.cost.split('/');
    const hasCommonResource = guessedResources.some(r => targetResources.includes(r));
    results.cost = hasCommonResource ? 'partial' : 'incorrect';
  }
  
  return results;
};

const getDisplayValue = (unit, categoryKey) => {
  const value = unit[categoryKey];
  return String(value).trim() === '' ? 'None' : String(value);
};

const aoe2UnitsLogic = {
  // Keep only what is unique to this game
  categories: [
    { key: 'age', label: 'Age' },
    { key: 'building', label: 'Building' },
    { key: 'unit_type', label: 'Type' },
    { key: 'range', label: 'Range' },
    { key: 'cost', label: 'Cost' }
  ],
  compareFunction: compareUnits,
  getDisplayValue,
  
  HintComponent: Aoe2UnitsHint,
  DirectoryComponent: Aoe2UnitDirectory,
  HowToPlayComponent: Aoe2UnitsHowToPlay,
  
  renderVictoryDetails: (unit) => (
    <div className="aoe2-units-game__unit-details">
      <strong>Hint:</strong> {unit.hint}
    </div>
  )
};

export default aoe2UnitsLogic;